import { AttachmentFileType } from '../AttachmentFileTypeEnum';

export class DragAndDropInfoDto {
  ID: string;
  Normal: string[];
  Strong: string;
  Emphasized: string;
  updateDate: string;
  icon: AttachmentFileType;
  imported?: boolean;
}
